"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpIdleTimeOutModal: {
        title: 'You are about to be signed out',
        content: 'Your session will timeout in',
        logOutButton: 'Log out now',
        extendButton: 'Extend my session',
    },
};
